import {Toast, ToastInitState} from '@/store/toast/toast.types';
import {ToastAction} from '@/store/toast/toast.actions';
import {ToastMutations} from '@/store/toast/toast.mutations';

const namespaced = true;

export const toastInitState: ToastInitState = {
 toast: {} as Toast
};

export const toastState = {
  namespaced,
  state: toastInitState,
  actions: ToastAction,
  mutations: ToastMutations
};
